import {
  GetCompanyQuery,
  GetCompanyQueryVariables,
  Tag,
} from "@/graphql/generated/graphql";
import { GetCompany } from "@/graphql/queries/GetCompany";
import { useQueryWrapper } from "@/hooks/useQueryWrapper/useQueryWrapper";
import { CompanyTag } from "@/store/slices/company_tags";
import { useBaseStore } from "@/store/store";
import { TagOption } from "./useTags.decl";

function mapToMultiSelectOption(tag: CompanyTag): TagOption {
  return {
    value: tag?.id ?? "",
    label: tag?.name ?? "",
    color: tag?.color ?? "",
  };
}

// Apparently only tags created in the admin portal can have a "description"
export function filterOutAdminPortalTags(tag: CompanyTag) {
  return !tag?.description;
}

const systemTags = ["voice_virtual_agent"];

export function filterOutSystemTags({ description }: Tag) {
  return description ? !systemTags.includes(description) : true;
}

export function transformTagData(data: CompanyTag[]) {
  return data.filter(filterOutAdminPortalTags).map(mapToMultiSelectOption);
}

export function useTags() {
  const setCompanyTags = useBaseStore((state) => state.setCompanyTags);

  const { loading } = useQueryWrapper<
    GetCompanyQuery,
    GetCompanyQueryVariables
  >(GetCompany, {
    onCompleted(data) {
      setCompanyTags(data.getCompany?.tags ?? []);
    },
  });

  return {
    loading,
  };
}
